import { INITIAL_REDUX_STATE } from 'vio-constants';
const mapboxState = {
    aws: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.AWS_LAYER,
    azure: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.AZURE_LAYER,
    displayedLocations: undefined,
    google: INITIAL_REDUX_STATE.DEFAULT_USER_SETTINGS.GOOGLE_LAYER,
    mapFeatureSources: undefined,
    previewFile: undefined,
    requestingMapFeatureSources: false,
    style: undefined
};
export default mapboxState;
